<template>
  <el-table
    class="base-table"
    v-loading="loading"
    :data="data"
    :empty-text="resolvedEmptyText"
    v-bind="$attrs"
    v-on="$listeners">
    <slot></slot>
  </el-table>
</template>

<script>
export default {
  name: 'BaseTable',
  inheritAttrs: false,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  computed: {
    resolvedEmptyText() {
      return this.emptyText || this.$t('settings.ldapTableEmpty');
    }
  }
};
</script>

<style lang="scss">
.base-table {
  width: 100%;

  .el-table__header-wrapper th,
  .el-table__fixed-header-wrapper th {
    background: #f8f9fc !important;
    color: #8a8fa8;
    font-size: 11px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: 0;
    border-bottom: 1px solid var(--border);
    padding: 12px 0;

    .cell {
      white-space: normal;
      word-break: break-word;
    }
  }

  .el-table__body-wrapper,
  .el-table__fixed-body-wrapper {
    tr td {
      border-bottom-color: #f0f0f5;
      padding: 14px 0;
      color: var(--text-primary);
      font-size: 13.5px;
    }

    tr:hover td,
    tr.hover-row td {
      background: var(--bg-hover) !important;
    }

    tr:last-child td {
      border-bottom: none;
    }
  }

  &::before {
    display: none;
  }
}
</style>
